type OwnProps = {
  label: string;
  target?: string;
  href: string;
  className?: string;
};

const defaultProps: Partial<OwnProps> = {
  target: "_new",
  className: "",
};

type Props = OwnProps & typeof defaultProps;

export function NavigationItemExternalLink({
  label,
  target,
  href,
  className,
}: Props) {
  return (
    <li>
      <a
        role="button"
        onClick={(e) => (e.target as $TSFixMe)?.blur()}
        href={href}
        target={target}
        className={className}
      >
        {label}
      </a>
    </li>
  );
}

NavigationItemExternalLink.defaultProps = defaultProps;

export default NavigationItemExternalLink;
